/**
 * ─── App Configuration ───
 *
 * Single source of truth for the API base URL.
 * In development: http://localhost:8080
 * In production:  set REACT_APP_API_URL in your environment
 *
 * Usage:  import { API_URL } from "../config";
 *         fetch(`${API_URL}/api/posts`)
 */

export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080";
